import React, { useEffect, useState } from 'react';
import { shape, string } from 'prop-types';
import { VARIANT_TYPE_CHANGED } from '../../constants/index';
import { onLifeCycleEvent, offLifeCycleEvent } from '../../utils/product-bundle-utils';
import { BundleAlertmessage } from './BundleAlertmessage';

const BundleVariantChangeAlert = ({
  alertSize,
  alertBodyText,
  alertHeadline,
  bundleProduct
}) => {
  const { showProductUpdateGeneralAlert } = bundleProduct?.features || {};

  const [alertBody, setalertBody] = useState(null);
  const [alertClosed, setAlertClosed] = useState(false);

  useEffect(() => {
    onLifeCycleEvent(VARIANT_TYPE_CHANGED, () => {
      setalertBody(alertBodyText);
    });

    return () => offLifeCycleEvent(VARIANT_TYPE_CHANGED);
  }, []);

  if (!alertBody || !showProductUpdateGeneralAlert || alertClosed) {
    return null;
  }

  return (
    <div data-component="BundleVariantChangeAlert">
      <BundleAlertmessage
        size={alertSize}
        content={{ main: alertBody }}
        headline={alertHeadline}
        onClose={() => setAlertClosed(true)}
      />
    </div>
  );
};

BundleVariantChangeAlert.propTypes = {
  alertSize: string,
  alertBodyText: string,
  alertHeadline: string,
  bundleProduct: shape({}).isRequired
};

BundleVariantChangeAlert.defaultProps = {
  alertBodyText: null,
  alertHeadline: null,
  alertSize: 'small'
};

BundleVariantChangeAlert.displayName = 'BundleVariantChangeAlert';

export { BundleVariantChangeAlert };